/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalDataQueryExecutionAPI
 * @hideconstructor
 * @classdesc Data query execution API class.
 */
define([], () => {
	class InternalDataQueryExecutionAPI {

		/**
		 * @function InternalDataQueryExecutionAPI#queryChanged
		 * @description Check if query is changed
		 * @protected
		 * 
		 * @return true if query spec has changed.
		 */
		queryChanged() {}

		/**
		 * @function InternalDataQueryExecutionAPI#getRawResults
		 * @description Get the post processed raw query results
		 * @protected
		 * @param {String} [id = 'data'] query dataset id
		 * 
		 * @return {Object} Raw query results
		 */
		getRawResult() {}

		/**
		 * @function InternalDataQueryExecutionAPI#setMinMaxQueryResults
		 * @description Add a spec with max min value as min max query results to the current query results
		 * @param {object} spec - includes data items and min max info
		 * Note - a falsy spec will remove the existing min max query results
		 * eg. 
		 * {
		 * 		reveuneavg: {
		 * 			min: 20,
		 * 	 	 	max: 100,
		 * 		 	columnId: 'revenue'
		 *  	}
		 * }
		 * @protected
		 * 
		 * @return {QueryResultsAPI} the current {@link QueryResultsAPI} object
		 */
		setMinMaxQueryResults() {}
	}

	return InternalDataQueryExecutionAPI;
});